import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SM_CONSTANTS } from '../../constants/sm-constants';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { ApiService } from 'src/app/providers/api.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'sm-add-edit-discounts',
  templateUrl: './add-edit-discounts.component.html',
  styleUrls: ['./add-edit-discounts.component.scss']
})
export class AddEditDiscountsComponent implements OnInit {
  home_status: any = sessionStorage.getItem('home_service_status')
  shop_status: any = sessionStorage.getItem('shop_service_status')
  virtual_status: any = sessionStorage.getItem('virtual_service_status')
  private _apiSubscription: Subscription = new Subscription();
  discountObj: any = {
    discountType: 2,
    discountAmount: null,
    minBillAmount: null,
    maxDiscount: null,
    start_date: '',
    end_date: '',
    otherDiscounts: 0,
    home_service_status: 0,
    shop_service_status: 0,
    virtual_service_status: 0,

  }
  constructor(@Inject(MAT_DIALOG_DATA) public parentData: any, private loaderservice: LoaderServiceService, private _apiservice: ApiService) { }

  ngOnInit(): void {
    let data = this.parentData.data

    this.discountObj.discountType = data.discountType ? data.discountType : 2
    this.discountObj.hashId = data.hashId
    this.discountObj.discountAmount = data.discountAmount
    this.discountObj.minBillAmount = data.minBillAmount 
    this.discountObj.maxDiscount = data.maxDiscount
    this.discountObj.start_date = data.start_date ? (data.start_date) : ''
    this.discountObj.end_date = data.end_date ? data.end_date : ''
    this.discountObj.otherDiscounts = data.otherDiscounts ? data.otherDiscounts : 0
    this.discountObj.shop_service_status = data.shop_service_status ? data.shop_service_status : 0
    this.discountObj.home_service_status = data.home_service_status ? data.home_service_status : 0
    this.discountObj.virtual_service_status = data.virtual_service_status ? data.virtual_service_status : 0

    this._apiSubscription = this._apiservice.apiResult.subscribe((resData) => {
      if(resData.responseType === SM_CONSTANTS.RESULT_API_ADD_EDIT_ENTITY_BILL_DISCOUNT){

        this.parentData.ref.closeAll();
      }
    })

  }
  selectCheck(event:any,value:any){
    if(event.checked){
      if(value == 0){
        this.discountObj.home_service_status = 1
      }
      else if(value == 1){
        this.discountObj.shop_service_status = 1
      }
      else if(value == 2){
        this.discountObj.virtual_service_status = 1
      }

    }
    else{
      if(value == 0){
        this.discountObj.home_service_status = 0
      }
      else if(value == 1){
        this.discountObj.shop_service_status = 0
      }
      else if(value == 2){
        this.discountObj.virtual_service_status = 0
      }
    }
 
  }
  onToggleChangeOtherDiscount(event:any){
    
    if(event.checked){
      this.discountObj.otherDiscounts = 1
    }else if(!event.checked){
      this.discountObj.otherDiscounts = 0

      
    }
  }

  onSubmitDiscountDetails(){

    let data = JSON.parse(JSON.stringify(this.discountObj))
    data.start_date = this.formatDate((new Date(data.start_date)).toLocaleDateString());
    data.end_date = this.formatDate((new Date(data.end_date)).toLocaleDateString());


    data.createdBy = data.editedBy = localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_HASH_ID)
    data.businessHashId = this.parentData.data.businessHashId

    Object.keys(data).forEach(key => {
      if ((data as any)[key] === null) {
        delete (data as any)[key];
      }
    });
    console.log(data);

    this.loaderservice.showLoader = true
    this._apiservice.addEditBillDiscount(data)
  }

  formatDate(originalDate: string): string {
    const parts = originalDate.split('/');
    const day = +parts[0];
    const month = +parts[1] - 1; // Months are 0-based in JavaScript
    const year = +parts[2];
    const date = new Date(year, month, day);

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Adding 1 to month since it's 0-based
    const dd = String(date.getDate()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
  }

}
